import React, { useContext, useEffect } from 'react'
import { AbilityContext } from 'components/Permissions/Can'

import BasicDashboard from './DashboardContext'
import StudentDashboard from './Student'
import { alerts } from 'keys'
import { roleNames } from 'keys/roles'
import { useDispatch } from 'react-redux'
import { actions } from 'store'

const WrapDashboard = (props) => {
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)
    const isSuperuser = ability.can("manage", "super-user")
    const isAdminContact = ability.can('manage', roleNames.school_setup) && !isSuperuser

    let DashboardComponent = BasicDashboard

    useEffect(() => {
        if (isAdminContact)
            dispatch(actions.setAlerts({
                key: alerts.schoolSetup,
                value: { open: true }
            }))
    }, [isAdminContact])

    return (
        <DashboardComponent {...props} />
    )
}

export default WrapDashboard